import { BASE_API_URL } from "../../../config";
import { authFetch } from "../../authHelper";

export const postCommands = {
  //

  async createCapture(imageData) {
    const { typePrefix, photoType, tierListName, listType, initialGroupByValue, customTiers, tierData, inspiredByCaptureId, allowTry } = this.state;
    const requestBody: any = {
      imageData,
      photoType: `${typePrefix} ${photoType}`,
      tierListName,
      listType: listType || null,
      groupBy: initialGroupByValue || null,
      allowTry: allowTry || false,
    };
    if (customTiers) requestBody.customTiers = customTiers;
    if (tierData) requestBody.tierData = tierData;
    if (inspiredByCaptureId) requestBody.inspiredByCaptureId = inspiredByCaptureId;

    const apiPath = `${BASE_API_URL}/api/createCapture`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify(requestBody),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    }
    return null;
  },

  async trackTry(captureId: number) {
    const apiPath = `${BASE_API_URL}/api/gallery/try`;
    fetch(apiPath, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ captureId }),
    }).catch(() => {});
  },

  async publishToGallery(captureId: number, thumbnail: string) {
    const apiPath = `${BASE_API_URL}/api/gallery/publish`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ captureId, thumbnail }),
    });
    return response;
  },

  async updateCapture(captureId: number, title?: string, description?: string) {
    const apiPath = `${BASE_API_URL}/api/gallery/update-capture`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ captureId, title, description }),
    });
    if (response.ok) {
      return await response.json();
    }
    return null;
  },

  async unpublishFromGallery(captureId: number) {
    const apiPath = `${BASE_API_URL}/api/gallery/unpublish`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ captureId }),
    });
    return response;
  },

  async voteOnGalleryItem(captureId: number, voteType: string) {
    const apiPath = `${BASE_API_URL}/api/gallery/vote`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ captureId, voteType }),
    });
    if (response.ok) {
      return await response.json();
    }
    return null;
  },

  async deleteCapture(captureId: number) {
    const apiPath = `${BASE_API_URL}/api/gallery/delete`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ captureId }),
    });
    if (response.ok) {
      return await response.json();
    }
    return null;
  },

  async toggleAllowTry(captureId: number) {
    const apiPath = `${BASE_API_URL}/api/gallery/toggle-try`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ captureId }),
    });
    if (response.ok) {
      return await response.json();
    }
    return null;
  },

  async deleteCustomItem(customItemId: number) {
    const apiPath = `${BASE_API_URL}/api/customItems/delete`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ customItemId }),
    });
    if (response.ok) {
      return await response.json();
    }
    return { success: false };
  },

  async addEmailList(email) {
    const apiPath = `${BASE_API_URL}/api/addEmailList`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ email }),
    });
    return response;
  },

  async removeEmailList() {
    const apiPath = `${BASE_API_URL}/api/removeEmailList`;
    const response = await authFetch(apiPath, {
      method: "POST",
    });
    return response;
  },

  trackDailyUsage() {
    const { typePrefix, listType } = this.state;
    const apiPath = `${BASE_API_URL}/api/TrackDailyUsage`;
    authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ type: typePrefix, listType }),
    }).catch(() => {});
  },

  async requestVerification(reason: string) {
    const apiPath = `${BASE_API_URL}/api/auth/request-verification`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ reason }),
    });
    if (response.ok) {
      return await response.json();
    }
    const data = await response.json();
    return { success: false, error: data.error || "Failed to submit request" };
  },

  async readNotification(notificationList, newReadIds) {
    let readNotes = [];
    notificationList.forEach((item) => {
      readNotes.push(item.notificationId);
    });
    readNotes.reverse();
    const uniqueNotesReadList = [...new Set(readNotes)].join(",");

    const apiPath = `${BASE_API_URL}/api/ReadNotification`;
    const requestBody = {
      uniqueNotesReadList: uniqueNotesReadList,
      newReadIds,
    };
    if (newReadIds.length > 0) {
      await authFetch(apiPath, {
        method: "POST",
        body: JSON.stringify(requestBody),
      });
    }
  },
};
